import {DependencyList, EffectCallback, useEffect, useLayoutEffect, useRef} from "react";

export const useThrottledEffect = (
    effect: EffectCallback,
    delay: number,
    deps: DependencyList = [],
    force?: boolean
) => {
    const lastRan = useRef(Date.now());

    useEffect(
        () => {
            if (!force) {
                const handler = setTimeout(function () {
                    if (Date.now() - lastRan.current >= delay) {
                        effect();
                        lastRan.current = Date.now();
                    }
                }, delay - (Date.now() - lastRan.current));

                return () => {
                    clearTimeout(handler);
                };
            } else {
                effect();
            }
        },
        [delay, ...deps],
    );
};

export const useDebouncedEffect = (
    effect: EffectCallback,
    delay: number,
    deps: DependencyList = [],
) => {
    useEffect(
        () => {
            const handler = setTimeout(effect, delay);
            return () => clearTimeout(handler);
        },
        [delay, ...deps],
    );
};

export const useDebouncedLayoutEffect = (
    effect: EffectCallback,
    delay: number,
    deps: DependencyList = [],
    force?: boolean
) => {
    useLayoutEffect(
        () => {
            if (force) {
                effect();
                return;
            }
            const handler = setTimeout(effect, delay);
            return () => clearTimeout(handler);
        },
        [delay, ...deps],
    );
};
